import styled from 'styled-components';
import { ReactComponent as WhatsApp } from '../media/whatsapp.svg';
import { AnchorHTMLAttributes } from 'react';

export function WhatsappButton() {
  return (
    <Wrapper
      title="WhatsApp"
      data-phone="393898836147"
      href="https://wa.me/393898836147"
      target="_blank"
    >
      <WhatsApp fill="var(--color-blue)" height={40} width={40}/>
    </Wrapper>
  )
}

const Wrapper = styled.a<AnchorHTMLAttributes<HTMLAnchorElement>>`
  display: flex;
  width: 70px;
  height: 70px;
  position: fixed;
  bottom: 1em;
  right: 20px;
  z-index: 2;
  border: none;
  align-items: center;
  justify-content: center;
  background: var(--color-gray-light);
  border-radius: 50%;
  box-shadow: 3px 5px 15px rgba(0,0,0,0.2);
`;

